import React from 'react'
import Dashboard from '@rd-web-markets/market/dist/dashboards/Dashboard';
import { DASHBOARD_PAGE_SIDE_BAR_MENU_ITEMS } from '@rd-web-markets/market/dist/constants';
import { useParams } from 'react-router-dom';
import claimGroupService from '@rd-web-markets/shared/dist/services/claim_group.service';
import { Loading } from '@rd-web-markets/shared/dist/util';
import ClaimGroupSidebarV2 from '@rd-web-markets/shared/dist/pages/setup/ClaimGroupSidebarV2';
import { useSetCompanyBreadcrumb } from '@rd-web-markets/shared/dist/util/hooks/useSetCompanyBreadcrumb';

const DashboardPage = ({accountType}) => {
  const { claimGroupId } = useParams();
  const [claimGroup] = claimGroupService.useGetClaimGroup(claimGroupId);
  const company = claimGroup?.company;

  useSetCompanyBreadcrumb(company, accountType);

  if (!claimGroup) return <Loading />;

  return (
    <>
      {claimGroup && (
        <ClaimGroupSidebarV2
          claimGroup={claimGroup}
          company={company}
          claims={claimGroup.claims}
          accountType={accountType}
          highlightedMenuItem='dashboard'
        />
      )}
      <div className='mt-3'></div>
        <Dashboard claimGroup={claimGroup} />
      <div className='mb-5'></div>
    </>
  );
};
export default DashboardPage;
